import React from "react";
import { styled } from "@acko-tech/building-blocks.ui.common";
import { AnchorLinkButton } from "@acko-tech/building-blocks.ui.button-old";

const TermAndConText = styled.div`
  color: #5b5675;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  ${(props) => props.styles}
  @media(max-width: 768px) {
    margin-top: 8px;
  }
`;

const LinkButton = styled(AnchorLinkButton)`
  font-weight: 500;
  font-size: 12px;
  line-height: 18px;
  color: #36354c;
  background-color: transparent;
  text-decoration-line: underline;
  border: none;
  padding: 5px 5px 5px 4px;
  display: inline-block;
  :active,
  :hover {
    background-color: transparent;
    text-decoration-line: underline;
    border: none;
    color: #36354c;
    box-shadow: none;
  }
`;

export default function TermAndCondition(props: any) {
  const { styles, text, underlinedText } = props;

  return (
    <TermAndConText styles={styles}>
      {text}
      <LinkButton
        href={`${process.env.HOST_URL}/gi/terms-and-conditions/`}
        target="_blank"
        rel="noreferrer"
      >
        {underlinedText}
      </LinkButton>
    </TermAndConText>
  );
}
